import { cn } from "@akina/utils";
import { Toaster as SonnerToaster, toast, type ToasterProps } from "sonner";
import { Icon } from "./atoms";

const COMMON_CLASSES =
  "!cursor-pointer !text-area !text-xs !rounded-[16px] !font-weight-[700] !shadow-none !gap-2 !px-6 !py-4";
const SUCCESS_CLASSES = "!bg-success-50 !text-success-900 !border-none";
const ERROR_CLASSES = "!bg-error-50 !text-error-900 !border-none";
const INFO_CLASSES = "!bg-info-50 !text-info-900 !border-none";
const WARNING_CLASSES = "!bg-warning-50 !text-warning-900 !border-none";
const LOADING_CLASSES = "!bg-gray-50 !text-gray-900 !border-none";

const INFO_OUTLINED_CLASSES = "!bg-info-50 !text-info-900 !border !border-gray-800/10";

function Toaster(props: Readonly<ToasterProps>) {
  return (
    <SonnerToaster
      theme="light"
      icons={{
        success: <Icon type="checkCircle" className="h-5 w-5" />,
        error: <Icon type="xOutline" className="h-5 w-5" />,
        info: <Icon type="info" className="h-5 w-5" />,
        warning: <Icon type="warningOutlined" className="h-5 w-5" />,
      }}
      toastOptions={{
        classNames: {
          toast: COMMON_CLASSES,
          success: SUCCESS_CLASSES,
          error: ERROR_CLASSES,
          info: INFO_CLASSES,
          warning: WARNING_CLASSES,
          loading: LOADING_CLASSES,
        },
      }}
      swipeDirections={["right", "left"]}
      position="top-center"
      offset={16}
      {...props}
    />
  );
}

// add custom toasts here if needed
function showCustomToast(
  message: string | React.ReactNode,
  { type, id }: { type: "infoOutlined" | "gray"; id?: string | number },
) {
  if (type === "infoOutlined")
    return toast(
      () => (
        <div className="flex items-center gap-2">
          <Icon type="info" className="h-5 w-5" />
          {message}
        </div>
      ),
      { id, className: cn(INFO_OUTLINED_CLASSES) },
    );
}

export { Toaster, showCustomToast };
